import styles from "./PersonalDetails.module.css";
import { profileResources } from "shared/data/portfolioData";
import Icon from "shared/components/Icons/Icon";
import ContactButton from "shared/components/Buttons/ContactButton/ContactButton";
import { trackSocialLinkClick } from "shared/services/analytics";
import { useFetch } from "shared/utils/useFetch";

const PersonalDetails = () => {
  const { data: profile } = useFetch("/api/profile", {
    name: "Arslan Kaleem",
    title: "Data Analyst & Software Engineer",
    location: "London, England",
    profilePhotoUrl: profileResources.profilePhoto,
    socialLinks: [
      { platform: "linkedin", label: "LinkedIn", url: "https://www.linkedin.com/in/arslan-kaleem/" },
      { platform: "github", label: "GitHub", url: "https://github.com/arslankaleem7229" },
      { platform: "stackoverflow", label: "Stack Overflow", url: "https://stackoverflow.com/users/15023395/arslan-kaleem" },
      { platform: "leetcode", label: "LeetCode", url: "https://leetcode.com/u/arslan_kaleem_/" },
      { platform: "upwork", label: "Upwork", url: "https://www.upwork.com/freelancers/~0101b7f905cba3a3c7" },
    ],
  });

  const photoSrc = profile.profilePhotoUrl || profileResources.profilePhoto;

  return (
    <div className={styles.container}>
      <img
        src={photoSrc}
        alt="Profile"
        className={styles.profileImage}
        loading="lazy"
      />
      <h2 className={styles.name}>{profile.name}</h2>
      <p className={styles.title}>{profile.title}</p>
      <p className={styles.location}>{profile.location}</p>
      <div className={styles.socialRow}>
        {profile.socialLinks.map((item) => (
          <a
            key={item.platform}
            href={item.url}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={item.label}
            onClick={() => trackSocialLinkClick(item.label)}
          >
            <Icon src={profileResources[item.platform]} alt={item.label} />
          </a>
        ))}
      </div>
      <ContactButton />
    </div>
  );
};

export default PersonalDetails;
